"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalizeService = void 0;
/**
 * A service that is used to provide the Globalize library number parsing.
 */
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
/**
 * The implementation of a service that is used to provide the Globalize library number parsing.
 */
class _GlobalizeService {
    constructor() {
        this._isInitialized = false;
        this._availableLocales = [];
        this.numberParserMap = new Map();
    }
    /**
     * True, if the service has been initialized.
     */
    get isInitialized() {
        return this._isInitialized;
    }
    /**
     * List of locales for which can be handled by the number parsing method.
     */
    get availableLocales() {
        return this._availableLocales.slice();
    }
    /**
     * Initialize the globalize service with the globalize object and the list of available locales.
     * This method must only be called once on application start.
     *
     * @param globalize The globalize object.
     * @param availableLocales The list of available locales.
     */
    // eslint-disable-next-line
    init(globalize, availableLocales) {
        if (this._isInitialized) {
            return;
        }
        this._availableLocales = availableLocales;
        this.numberParserMap.clear();
        this._availableLocales.forEach((locale) => {
            this.numberParserMap.set(locale, globalize(locale).numberParser());
        });
        if (this.onInitResolve) {
            this.onInitResolve(this);
            this.onInitPromise = undefined;
            this.onInitResolve = undefined;
        }
        this._isInitialized = true;
    }
    /**
     * Register for the onInit event.
     *
     * @returns A Promise that returns the initialized Globalize Service.
     */
    onInit() {
        if (this._isInitialized) {
            return Promise.resolve(this);
        }
        else {
            if (!this.onInitPromise) {
                this.onInitPromise = new Promise((resolve, reject) => {
                    this.onInitResolve = resolve;
                });
            }
            return this.onInitPromise;
        }
    }
    /**
     * Converts a localized number string to a number.
     *
     * @param localizedString The localized number string.
     * @param locale The locale that should be used for the conversion.
     * @returns Returns a number or undefined if the localized string couldn't be parsed.
     */
    localizedStringToNumber(localizedString, locale) {
        if (!this._isInitialized) {
            return undefined;
        }
        let numberParser = this.numberParserMap.get(locale);
        if (!numberParser) {
            let truncatedLocale = locale;
            let lastMinusIndex;
            while ((lastMinusIndex = truncatedLocale.lastIndexOf('-')) !== -1 && !numberParser) {
                truncatedLocale = truncatedLocale.substring(0, lastMinusIndex);
                numberParser = this.numberParserMap.get(truncatedLocale);
            }
        }
        if (numberParser) {
            const parsedNumber = numberParser(localizedString);
            if (echain_shared_ts_utils_1.NumberUtils.isDefinedNumber(parsedNumber)) {
                return parsedNumber;
            }
        }
        return undefined;
    }
}
/**
 * Exported GlobalizeService instance.
 *
 * @type {GlobalizeService}
 */
exports.globalizeService = new _GlobalizeService();
//# sourceMappingURL=GlobalizeService.js.map